import React from "react"
import { Box } from "@nivo/core"
import ReactTooltip from "react-tooltip"
import { BarDatum, ResponsiveBar } from "@nivo/bar"
import { DataTableCellAlphaNumeric } from "@walmart-web/livingdesign-components"
import "./index.scss"

interface TooltipProps {
	id: string
}

interface ChartCellProps {
	id: string
	data: BarDatum[]
	height?: string | number
	maxValue?: number | "auto"
	colors?: string[]
	keys?: string[]
	margin?: Box
	padding?: number
	innerPadding?: number
	indexBy?: string
}

const Tooltip: React.FC<TooltipProps> = ({ id, children }) => {
	return (
		<ReactTooltip
			id={id}
			className="chart-cell-tooltip"
			backgroundColor="transparent"
			getContent={() => (
				<div className="tooltip-table chart-cell-content">{children}</div>
			)}
		/>
	)
}

export const ChartCell: React.FC<ChartCellProps> = ({
	id,
	height = "2.5rem",
	children,
	...props
}) => (
	<DataTableCellAlphaNumeric data-tip data-for={id}>
		{children && <Tooltip id={id}>{children}</Tooltip>}
		<div style={{ height }}>
			<ResponsiveBar
				groupMode="grouped"
				layout="horizontal"
				enableLabel={false}
				isInteractive={false}
				enableGridX={false}
				enableGridY={false}
				{...props}
			/>
		</div>
	</DataTableCellAlphaNumeric>
)
